import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentStack24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDocumentStack24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 17.5v-6.444a2 2 0 0 0-.582-1.41l-.145-.147H18.5V16a1.5 1.5 0 0 1-1.5 1.5m-2.49-9.773v-3.89l3.845 3.866a.5.5 0 0 1 .142.296h-3.715zm-1.5-1.509-.623-.628A2 2 0 0 0 10.968 5H8.5A1.5 1.5 0 0 1 10 3.5h3.01zM7 5a3 3 0 0 1 3-3h3.968a2 2 0 0 1 1.418.59l4.032 4.056A2 2 0 0 1 20 8.056V16a3 3 0 0 1-3 3 3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 15.5h7a1.5 1.5 0 0 0 1.5-1.5v-6.5h-5.49v-6H7A1.5 1.5 0 0 0 5.5 8v11A1.5 1.5 0 0 0 7 20.5m8.355-9.797a.5.5 0 0 1 .142.296H11.51V6.837z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentStack24);
